import * as React from 'react';
import {
  Terminator,
  terminatorSuggestionToTerminatorProps,
} from './terminator';
import { withExperiments } from '../../../component-decorators/with-experiments';
import type { InjectedExperimentsProps } from '@wix/wix-experiments-react';
import type { ITerminatorSuggestion } from './terminator-data';
import { getTerminatorSuggestion } from './terminator-data';
import type { MarketplaceStore } from '../../../component-decorators/with-marketplace-store';
import { withMarketplaceStore } from '../../../component-decorators/with-marketplace-store';

export interface ITerminatorContainerProps
  extends Partial<InjectedExperimentsProps> {
  marketplaceStore?: MarketplaceStore;
  term: string;
  fullWidth?: boolean;
  isMobile?: boolean;
}

@withExperiments
@withMarketplaceStore
export class TerminatorContainer extends React.Component<ITerminatorContainerProps> {
  render() {
    const { term, experiments, marketplaceStore, fullWidth, isMobile } =
      this.props;
    const suggestion: ITerminatorSuggestion = term
      ? getTerminatorSuggestion(term, experiments)
      : null;
    return suggestion ? (
      <Terminator
        {...terminatorSuggestionToTerminatorProps(
          this.props.term,
          suggestion,
          marketplaceStore,
          fullWidth,
          isMobile,
        )}
      />
    ) : null;
  }
}
